/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment-timezone';

import 'react-datetime/css/react-datetime.css';
import * as S from '../../styles';

export interface IDateTimePickerProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    required?: boolean;
    readOnly?: boolean;
    placeholder?: string;
    timeZone?: string;
    hasError?: boolean;
    onCompChange?(id: string, payload: any): void;
}

export const DateTimePicker = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    value,
    required,
    placeholder,
    timeZone,
    readOnly,
    hasError,
    onCompChange,
}: IDateTimePickerProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [isInvalid, setInvalid] = useState(false);

    useEffect(() => {
        setInvalid(hasError);
    }, [hasError]);
    const onChange = (id: string, e: any) => {
        setTextValue(e);
        onCompChange && onCompChange(id, moment(e).format());
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <Datetime
                    displayTimeZone={timeZone}
                    timeFormat={true}
                    closeOnSelect={true}
                    dateFormat="DD/MM/YYYY"
                    onChange={onChange.bind(null, id)}
                    renderInput={(props, openCalendar) => (
                        // <InputGroup className="inputcontrol shadow-none">
                        //     <InputGroup.Text className="inputcontrol shadow-none">
                        //         <CalendarIcon className="icon icon-xs" />
                        //     </InputGroup.Text>
                        <InputGroup>
                            <S.FormControl
                                fontScale={fontScale}
                                className="formcontrol shadow-none"
                                required={required}
                                type="text"
                                value={
                                    textValue
                                        ? timeZone
                                            ? moment
                                                  .tz(textValue, timeZone)
                                                  .format('DD/MM/YYYY hh:mm a')
                                            : moment(textValue)?.format(
                                                  'DD/MM/YYYY hh:mm a'
                                              )
                                        : ''
                                }
                                placeholder="mm/dd/yyyy hh:mm a"
                                onFocus={openCalendar}
                                onChange={() => {}}
                                readOnly={readOnly}
                                isInvalid={isInvalid}
                            />
                            <InputGroup>{_renderErrorTextIf()}</InputGroup>
                        </InputGroup>
                    )}
                />
            </Form.Group>
        </>
    );
};

DateTimePicker.defaultProps = {
    required: false,
    readOnly: false,
    hasError: false,
    timeZone: null,
};
